import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { SwitchSmall } from './SwitchSmall.js';
import { SwitchDefault } from './SwitchDefault.js';
import { comfortable } from './Switch.tokens.js';
import { typographyTemplate, useToken } from '@equinor/eds-utils';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useEds } from '../EdsProvider/eds.context.js';

var _excluded = ["size", "disabled", "label", "className", "style"];
var StyledLabel = styled.label.withConfig({
  displayName: "Switch__StyledLabel",
  componentId: "sc-sdaahx-0"
})(["cursor:", ";border:none;background-color:transparent;vertical-align:middle;display:inline-flex;align-items:center;position:relative;gap:", ";"], function (_ref) {
  var $isDisabled = _ref.$isDisabled;
  return $isDisabled ? 'not-allowed' : 'pointer';
}, function (_ref2) {
  var $size = _ref2.$size;
  return $size === 'small' ? '12px' : '8px';
});
var Label = styled.span.withConfig({
  displayName: "Switch__Label",
  componentId: "sc-sdaahx-1"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["", ";"], typographyTemplate(theme.typography));
});
var Switch = /*#__PURE__*/forwardRef(function Switch(_ref4, ref) {
  var _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'default' : _ref4$size,
    disabled = _ref4.disabled,
    label = _ref4.label,
    className = _ref4.className,
    style = _ref4.style,
    rest = _objectWithoutProperties(_ref4, _excluded);
  var _useEds = useEds(),
    density = _useEds.density;
  // TODO Temporary workaround untill we can deprecate "size" property (controlled by EdsProvider in the future)
  var overrideDensity = size === 'small' ? 'compact' : density;
  var token = useToken({
    density: overrideDensity
  }, comfortable);
  return /*#__PURE__*/jsx(ThemeProvider, {
    theme: token,
    children: label ? /*#__PURE__*/jsxs(StyledLabel, {
      $size: size,
      $isDisabled: disabled,
      className: className,
      style: style,
      children: [size === 'small' ? /*#__PURE__*/jsx(SwitchSmall, _objectSpread(_objectSpread({
        disabled: disabled
      }, rest), {}, {
        ref: ref
      })) : /*#__PURE__*/jsx(SwitchDefault, _objectSpread(_objectSpread({
        disabled: disabled
      }, rest), {}, {
        ref: ref
      })), label && /*#__PURE__*/jsx(Label, {
        children: label
      })]
    }) : size === 'small' ? /*#__PURE__*/jsx(SwitchSmall, _objectSpread(_objectSpread({
      disabled: disabled,
      className: className,
      style: style
    }, rest), {}, {
      ref: ref
    })) : /*#__PURE__*/jsx(SwitchDefault, _objectSpread(_objectSpread({
      disabled: disabled,
      className: className,
      style: style
    }, rest), {}, {
      ref: ref
    }))
  });
});
Switch.displayName = 'Switch';

export { Switch };
